function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.757,7.288V43.626c0,3.773,8.445,6.832,18.861,6.832V7.288H5.757Z",
  transform: "translate(-5.757 -0.457)",
  fill: "#19457a"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M24.243,50.456H24.5c10.416,0,18.861-3.057,18.861-6.831V7.288H24.243Z",
  transform: "translate(-5.641 -0.457)",
  fill: "#0072c6"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M24.243,50.456H24.5c10.416,0,18.861-3.057,18.861-6.831V7.288H24.243Z",
  transform: "translate(-5.641 -0.457)",
  fill: "#fff",
  opacity: 0.15
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M43.478,7.331c0,3.773-8.445,6.831-18.861,6.831S5.757,11.1,5.757,7.331,14.2.5,24.618.5,43.478,3.558,43.478,7.331",
  transform: "translate(-5.757 -0.5)",
  fill: "#fff"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M39.6,6.925c0,2.491-6.718,4.507-15,4.507S9.588,9.416,9.588,6.925s6.719-4.507,15.006-4.507,15,2.018,15,4.507",
  transform: "translate(-5.733 -0.487)",
  fill: "#046eab"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M36.455,9.679C38.419,8.918,39.6,7.964,39.6,6.927c0-2.491-6.718-4.508-15.006-4.508s-15,2.018-15,4.508c0,1.036,1.18,1.99,3.145,2.752a35.033,35.033,0,0,1,11.86-1.752A35.044,35.044,0,0,1,36.455,9.679",
  transform: "translate(-5.733 -0.487)",
  fill: "#1590cf"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M18.6,32.409a3.1,3.1,0,0,1-1.229,2.623,5.509,5.509,0,0,1-3.394.93,6.456,6.456,0,0,1-3.08-.664V32.641a4.752,4.752,0,0,0,3.146,1.213,2.14,2.14,0,0,0,1.283-.332,1.039,1.039,0,0,0,.453-.88,1.232,1.232,0,0,0-.436-.938,8.005,8.005,0,0,0-1.772-1.029q-2.723-1.277-2.723-3.486a3.147,3.147,0,0,1,1.187-2.569,4.843,4.843,0,0,1,3.154-.967,7.88,7.88,0,0,1,2.889.457V26.59a4.709,4.709,0,0,0-2.739-.83,2.028,2.028,0,0,0-1.22.327,1.032,1.032,0,0,0-.448.875,1.25,1.25,0,0,0,.361.926,5.841,5.841,0,0,0,1.481.893,7.339,7.339,0,0,1,2.379,1.6,2.984,2.984,0,0,1,.707,2.026ZM31.4,29.72a6.791,6.791,0,0,1-.955,3.644,5.1,5.1,0,0,1-2.689,2.167l3.453,3.2H27.725L25.26,35.962a5.78,5.78,0,0,1-2.86-.838,5.253,5.253,0,0,1-1.967-2.137,6.559,6.559,0,0,1-.693-3.026,7.073,7.073,0,0,1,.751-3.3A5.336,5.336,0,0,1,22.6,24.432a6.172,6.172,0,0,1,3.121-.78,5.742,5.742,0,0,1,2.942.756,5.154,5.154,0,0,1,2.017,2.149A6.8,6.8,0,0,1,31.4,29.72Zm-2.822.15a4.657,4.657,0,0,0-.789-2.86,2.553,2.553,0,0,0-2.158-1.051A2.71,2.71,0,0,0,23.4,27.013a4.383,4.383,0,0,0-.838,2.806,4.373,4.373,0,0,0,.821,2.784,2.641,2.641,0,0,0,2.183,1.042,2.677,2.677,0,0,0,2.2-1.008A4.278,4.278,0,0,0,28.581,29.87Zm11.877,5.885H33.37v-11.9H36.05V33.58h4.408Z",
  transform: "translate(-5.725 -0.354)",
  fill: "#fff"
});

var SvgSqlDb = function SvgSqlDb(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37.722,
    height: 50,
    viewBox: "0 0 37.722 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSqlDb, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sql_db.00458468.svg";
export { ForwardRef as ReactComponent };